import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { stringify } from 'querystring';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Addexpense } from './addexpense';
import { AppComponent } from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
declare var $: any;
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

export class EDIFileData {
  fileBase = [];
  fileName: string;
  ProfileID: number;
  NoticeNo: number;
  ExpenseId: string;
}

export interface ColumnList {
  colList: string;
  EDIRowID: string;
  Status: number;
  Message: string;
}
export interface NoticeCaseStatus {
  NoticeStatus: string;
  ConvertinCase: string;
}
export interface CaseNotice {
  ID: number;
  refno: string;
  type: string;
  NoticeDt: any;
}
@Component({
    selector: 'app-expense',
    templateUrl: './expense.component.html',
    styleUrls: ['./expense.component.css'],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})

// kks



export class ExpenseComponent implements OnInit {
  url: string;
  ExpenseForForm: FormGroup;
  Noticeid: number;
  numb: any;
  pageurl: string;
  minDate = new Date(1990, 0, 1);
  currentDate = new Date();
  maxDate = this.currentDate;
  ExpenseDate: string;
  ButtonCaption: string;
  expenseID: any;
  ExpenseNatureData: any;
  EmployeeData: any;
  LawyerData: any;
  RegionData: any;
  BranchData: any;
  ExpenseSubCategoryData: any;
  UnitRate4: number;
  NoofUnit4: number;
  HideCol: string;
  expenseAmount: any;
  editable: boolean;
  SelectedCaseNotice: number;
  CaseNoticeList: CaseNotice[] = [];
  DisableValue: boolean;
  NoticeCurrentID: any;
  HideButtonSubmit: string;
  NoticeCaseStatus: string;
  RightsID: string;
  RouteGMNatureOfExpense: string;
  RouteGMRegion: string;
  RouteGMBranch: string;
  ExpenseCategory: any;
  ExpenseSubCategory: any;
  RouteGMExpenseSubCategory: string;
  HideEmployee: string;
  HideLawyer: string;
  Hide: any;
  ReasonExpense: string;
  IsDisplayButton: string;
  Status: string;
  StatusType: string;
  FullyFileData: any;
  // Import Expense
  ModuleData: any;
  GetPreviewDownloadFile: any;
  EDIData: any;
  fileurls = [];
  fileName: string;
  EDIRowID: string;
  AddExpenseIDFileUpload: any;
  CurrentStep: number;
  Msg: string;
  class: string;
  ImportType: string;
  loading: boolean;
  DownloadURL: string;
  DownloadFilePath: string;
  TargetFile: string;
  Status1: number;
  // Import expense


  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  ProfileID: number;
  // tslint:disable-next-line: max-line-length
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, public datepipe: DatePipe, protected alertService: AlertService) {
    this.url = AppComponent.baseURL;
  }

  ngOnInit() {
    this.Status = "0";
    this.AddExpenseIDFileUpload = "";
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202026001') || this.RightsID.includes('202026021') || this.RightsID.includes('202026000')) {
    } else {
      window.location.href = "module/0";
    }
    if (this.RightsID.includes('202028041')) {
      this.IsDisplayButton = "1";
    } else {
      this.IsDisplayButton = "0";
    }
    // tslint:disable-next-line: max-line-length
    this.RouteGMNatureOfExpense = this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021') ? 'general-master/065' : 'module/0';
    this.RouteGMRegion = this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021') ? 'general-master/085' : 'module/0';
    this.RouteGMBranch = this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021') ? 'general-master/090' : 'module/0';
    this.RouteGMExpenseSubCategory = this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021') ? 'general-master/120' : 'module/0';
    this.UnitRate4 = 0;
    this.NoofUnit4 = 1;
    this.HideCol = "!isHidden";
    this.HideEmployee = "!isHidden";
    this.HideLawyer = "!isHidden";
    this.Hide = "!isHidden";
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.Noticeid = +pagehead[2];
    this.HideButtonSubmit = "";
    this.http.get(this.url + 'Notice/Fetch_Notice_Case_Status?id=' + this.Noticeid)
      .subscribe((data) => {
        if (data == null) {
        } else {
          const noticeCaseStatus: NoticeCaseStatus = JSON.parse(data.toString())[0];
          this.NoticeCaseStatus = noticeCaseStatus.NoticeStatus;
          if (this.NoticeCaseStatus == "1") {
            this.HideButtonSubmit = "!isHidden";
          }
        }
      }
      );
    this.FetchHelpCaseNotice();
    this.GetExpenseCategory();
    this.getMaster('065', '').subscribe((data: any) => { this.ExpenseNatureData = data; });
    this.getMaster('085', '').subscribe((data: any) => { this.RegionData = data; });
    this.getMaster('090', '').subscribe((data: any) => { this.BranchData = data; });
    this.getMaster('120', '').subscribe((data: any) => { this.ExpenseSubCategoryData = data; });
    this.http.get(this.url + 'GM/GetEmployee').subscribe((data) => {
      this.EmployeeData = JSON.parse(data.toString());
    });
    this.http.get(this.url + 'Help/FetchHelpLawyerName').subscribe((data) => {
      this.LawyerData = JSON.parse(data.toString());
    });

    if (this.Noticeid > 0) {
      this.ExpenseForForm = this.formBuilder.group({
        // tslint:disable-next-line: max-line-length
        ExpenseDate: ['', Validators.required], NatureofExpense: ['', Validators.required], Employee: [''], Lawyer: [''], Region: ['', Validators.required], Branch: ['', Validators.required], ExpenseCategory: ['', Validators.required], ExpenseSubCategory: ['', Validators.required], Description: ['', Validators.required], UnitRate: ['', [Validators.required, Validators.min(1)]], NoofUnit: [''], drpCaseNotice: [{ value: null, disabled: true }, Validators.required], Reason: ['']
      });
    } else {
      this.ExpenseForForm = this.formBuilder.group({
        // tslint:disable-next-line: max-line-length
        ExpenseDate: ['', Validators.required], NatureofExpense: ['', Validators.required], Employee: [''], Lawyer: [''], Region: ['', Validators.required], Branch: ['', Validators.required], ExpenseCategory: ['', Validators.required], ExpenseSubCategory: ['', Validators.required], Description: ['', Validators.required], UnitRate: ['', [Validators.required, Validators.min(1)]], NoofUnit: [''], drpCaseNotice: [null,Validators.required], Reason: ['']
      });

    }
    this.ExpenseForForm.patchValue({ NatureofExpense: null, Employee: null, Lawyer: null, Region: null, Branch: null, ExpenseCategory: null, ExpenseSubCategory: null });
    this.expenseID = pagehead[3];
    if (this.expenseID == "0") {
      this.ButtonCaption = "Add";
    } else {
      this.ButtonCaption = "Update";
      this.FetchExpenseDetail();
      this.GETEXPENSEFILE();
    }
  }


  get f () { return this.ExpenseForForm.controls; }
  FetchExpenseDetail() {
    if (this.Noticeid != 0) {
      this.NoticeCurrentID = this.Noticeid;
    } else { this.NoticeCurrentID = ""; }
    this.http.get(this.url + 'Notice/FetchExpense?NoticeID=' + this.NoticeCurrentID + '&ExpenseID=' + this.expenseID)
      .subscribe((data) => {
        if (data == null) { } else {
          const AddExpense: Addexpense = JSON.parse(data.toString())[0];
          let latest_date = this.datepipe.transform(AddExpense.Date, 'yyyy-MM-dd');
          if (AddExpense.ExpenseCategoryID == "1") {
            this.ExpenseForForm.patchValue({ Employee: AddExpense.EmployeeID, Lawyer: 0 });
            this.HideEmployee = "";
            this.Hide = "";
          } else if (AddExpense.ExpenseCategoryID == "2") {
            this.ExpenseForForm.patchValue({ Lawyer: AddExpense.EmployeeID, Employee: 0 });
            this.HideLawyer = "";
            this.Hide = "";
          }
          this.ReasonExpense = AddExpense.Reason;
          //Status
          this.Status = AddExpense.ApproveStatus;
          if (this.Status == "0") { this.StatusType = "Pending"; }
          if (this.Status == "1") { this.StatusType = "Approved"; this.HideButtonSubmit = "!isHidden"; }
          if (this.Status == "2") { this.StatusType = "Rejected"; this.HideButtonSubmit = "!isHidden"; }
          this.ExpenseForForm.patchValue({
            NatureofExpense: +AddExpense.ExpenseNatureID, Region: +AddExpense.RegionID, Branch: +AddExpense.BranchID, ExpenseCategory: AddExpense.ExpenseCategoryID, ExpenseSubCategory: +AddExpense.ExpenseSubCategoryID, Description: AddExpense.Description, UnitRate: AddExpense.UnitRate,
            NoofUnit: AddExpense.UnitCount, ExpenseDate: latest_date, Reason: AddExpense.Reason
          });
        }
      }
      );
  }




  onNatureofExpenseChange(selectedItem: any) {
    if (selectedItem) {
      const val = selectedItem.numval1;
      this.UnitRate4 = val;
    } else {
      this.UnitRate4 = 0;
    }
  }

  onCategorySelect(value : any) {
    const GenID = value.SubID;
    if (GenID == 1) {
      this.HideEmployee = "";
      this.HideLawyer = "!isHidden";
      this.Hide = "";
    }
    else if (GenID == 2) {
      this.HideLawyer = "";
      this.HideEmployee = "!isHidden";
      this.Hide = "";
    }
    else {
      this.HideEmployee = "!isHidden";
      this.HideLawyer = "!isHidden";
      this.Hide = "!isHidden";
    }
  }
  GetExpenseCategory() {
    this.http.get(this.url + 'Notice/GetExpenseCategory')
      .subscribe((data) => {
        this.ExpenseCategory = JSON.parse(data.toString());
      });
  }
  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
      .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  }
  FetchHelpCaseNotice() {
    this.http.get(this.url + 'Help/FetchHelpRefNoNoticeCase?id=' + this.Noticeid)
      .subscribe((data) => {
        if (data == null) {
          this.CaseNoticeList = null;
        } else {
          this.CaseNoticeList = JSON.parse(data.toString());
          if (this.Noticeid > 0) {
            this.ExpenseForForm.patchValue({ drpCaseNotice: this.Noticeid });
            // this.SelectedCaseNotice = this.Noticeid;
          }
        }
      }
      );
  }
  onExpenseFormSubmit(ExpenseFormdata) {
    if (this.ExpenseForForm.invalid) {
      this.ExpenseForForm.markAllAsTouched();
      return;
    }
    if (ExpenseFormdata.Region == 0) { this.alertService.showWarning('Please Select Region'); return; }
    if (ExpenseFormdata.Branch == 0) { this.alertService.showWarning('Please Select Branch'); return; }
    if (ExpenseFormdata.ExpenseCategory == 0) { this.alertService.showWarning('Please Select Expense Category'); return; }
    if (this.Noticeid == 0) {
      this.Noticeid = ExpenseFormdata.drpCaseNotice;
    }
    let datavalue = ExpenseFormdata.NatureofExpense;
    let dataRegion = ExpenseFormdata.Region;
    let dataBranch = ExpenseFormdata.Branch;
    let dataCategory = ExpenseFormdata.ExpenseCategory;
    let dataSubcategory = ExpenseFormdata.ExpenseSubCategory;
    let dataEmployee;
    // if(dataCategory!=1){ExpenseFormdata.Employee=0;}
    if (dataCategory == 1) {
      dataEmployee = ExpenseFormdata.Employee;
    } else if (dataCategory == 2) {
      dataEmployee = ExpenseFormdata.Lawyer;
    } else {
      dataEmployee = 0;
    }
    if (ExpenseFormdata.Description == "") {
      this.alertService.showWarning('Please Enter Expense Description');
    } else if (ExpenseFormdata.NatureofExpense == "0") {
      this.alertService.showWarning('Please Select Nature of Expense');
    } else {
      if (this.ExpenseForForm.invalid) { return; }
      let ae: Addexpense = {
        id: this.expenseID,
        NoticeID: this.Noticeid,
        Description: ExpenseFormdata.Description,
        UnitRate: ExpenseFormdata.UnitRate,
        UnitCount: ExpenseFormdata.NoofUnit,
        Value: ExpenseFormdata.UnitRate * ExpenseFormdata.NoofUnit,
        Date: ExpenseFormdata.ExpenseDate,
        ExpenseNatureID: datavalue,
        RegionID: dataRegion,
        BranchID: dataBranch,
        ExpenseCategoryID: dataCategory,
        ExpenseSubCategoryID: dataSubcategory,
        EmployeeID: dataEmployee,
        recUser: parseInt(localStorage.getItem('LoginUserID')),
        Reason: ExpenseFormdata.Reason,
        ApproveStatus: "0"
      }

      this.http.post(this.url + 'Notice/insertNoticeExpense', ae).subscribe((data) => {
        if (data == null) {
            this.alertService.showError('Expense Not Submitted');
        } else {
          if (this.expenseID == "0") {
            this.AddExpenseIDFileUpload = JSON.parse(data.toString());
            this.ExpenseFileUpload(this.AddExpenseIDFileUpload[0].ExpenseID);

            this.alertService.showSuccess('Expense Submitted');


            this.AddExpenseIDFileUpload = "";

            this.expenseID = "";
            this.ReasonExpense = "";
            this.ExpenseForForm.reset();
            this.ExpenseForForm.patchValue({
              drpCaseNotice: this.Noticeid
            })
            // this.ExpenseForForm.patchValue({
            //   // NatureofExpense: "0", Region: '0', Branch: '0',ExpenseCategory: '0', ExpenseSubCategory: '0', Description: "", UnitRate: "0", NoofUnit: "0", ExpenseDate: "", drpCaseNotice: null});
            //   NatureofExpense: null, Region: null, Branch: null, ExpenseCategory: null, ExpenseSubCategory: null, Description: null, UnitRate: null, NoofUnit: null, ExpenseDate: null, drpCaseNotice: null
            // });
          } else {
            this.alertService.showSuccess('Expense Updated');
          }
        }
      }
      );
    }
  }
  Approve(ExpenseFormdata) {
    if (ExpenseFormdata.Reason == "") { this.alertService.showWarning('Please Enter Reason'); return; }
    if (ExpenseFormdata.Region == 0) { this.alertService.showWarning('Please Select Region'); return; }
    if (ExpenseFormdata.Branch == 0) { this.alertService.showWarning('Please Select Branch'); return; }
    if (ExpenseFormdata.ExpenseCategory == 0) { this.alertService.showWarning('Please Select Expense Category'); return; }
    if (this.Noticeid == 0) {
      this.Noticeid = ExpenseFormdata.drpCaseNotice;
    }
    let datavalue = ExpenseFormdata.NatureofExpense.split(',');
    let dataRegion = ExpenseFormdata.Region.split(',');
    let dataBranch = ExpenseFormdata.Branch.split(',');
    let dataCategory = ExpenseFormdata.ExpenseCategory.split(',');
    let dataSubcategory = ExpenseFormdata.ExpenseSubCategory.split(',');
    let dataEmployee;
    // if(dataCategory!=1){ExpenseFormdata.Employee=0;}
    if (dataCategory == 1) {
      dataEmployee = ExpenseFormdata.Employee.split(',');
    } else if (dataCategory == 2) {
      dataEmployee = ExpenseFormdata.Lawyer.split(',');
    } else {
      dataEmployee = 0;
    }
    if (ExpenseFormdata.Description == "") {
      this.alertService.showWarning('Please Enter Expense Description');
    } else if (ExpenseFormdata.NatureofExpense == "0") {
      this.alertService.showWarning('Please Select Nature of Expense');
    } else {
      if (this.ExpenseForForm.invalid) { return; }
      let ae: Addexpense = {
        id: this.expenseID,
        NoticeID: this.Noticeid,
        Description: ExpenseFormdata.Description,
        UnitRate: ExpenseFormdata.UnitRate,
        UnitCount: ExpenseFormdata.NoofUnit,
        Value: ExpenseFormdata.UnitRate * ExpenseFormdata.NoofUnit,
        Date: ExpenseFormdata.ExpenseDate,
        ExpenseNatureID: datavalue[0],
        RegionID: dataRegion[0],
        BranchID: dataBranch[0],
        ExpenseCategoryID: dataCategory[0],
        ExpenseSubCategoryID: dataSubcategory[0],
        EmployeeID: dataEmployee[0],
        recUser: parseInt(localStorage.getItem('LoginUserID')),
        Reason: ExpenseFormdata.Reason,
        ApproveStatus: "1"
      }

      this.http.post(this.url + 'Notice/insertNoticeExpense', ae).subscribe((data) => {
        if (data == null) {
          this.alertService.showError('Expense Not Submitted');
        } else {
          if (this.expenseID == "0") {
            this.alertService.showSuccess('Expense Submitted');
            this.ExpenseForForm.patchValue({
              // NatureofExpense: "0", Region: '0', Branch: '0',ExpenseCategory: '0', ExpenseSubCategory: '0', Description: "", UnitRate: "0", NoofUnit: "0", ExpenseDate: "", drpCaseNotice: null});
              NatureofExpense: "0", Region: '0', Branch: '0', ExpenseCategory: '0', ExpenseSubCategory: '0', Description: "", UnitRate: "0", NoofUnit: "0", drpCaseNotice: null
            });
          } else {
            this.alertService.showSuccess('Expense Updated');
          }
        }
      }
      );
    }
  }
  Reject(ExpenseFormdata) {
    if (ExpenseFormdata.Reason == "") { this.alertService.showWarning('Please Select Reason'); return; }
    if (ExpenseFormdata.Region == 0) { this.alertService.showWarning('Please Select Region'); return; }
    if (ExpenseFormdata.Branch == 0) { this.alertService.showWarning('Please Select Branch'); return; }
    if (ExpenseFormdata.ExpenseCategory == 0) { this.alertService.showWarning('Please Select Expense Category'); return; }
    if (this.Noticeid == 0) {
      this.Noticeid = ExpenseFormdata.drpCaseNotice;
    }
    let datavalue = ExpenseFormdata.NatureofExpense.split(',');
    let dataRegion = ExpenseFormdata.Region.split(',');
    let dataBranch = ExpenseFormdata.Branch.split(',');
    let dataCategory = ExpenseFormdata.ExpenseCategory.split(',');
    let dataSubcategory = ExpenseFormdata.ExpenseSubCategory.split(',');
    let dataEmployee;
    // if(dataCategory!=1){ExpenseFormdata.Employee=0;}
    if (dataCategory == 1) {
      dataEmployee = ExpenseFormdata.Employee.split(',');
    } else if (dataCategory == 2) {
      dataEmployee = ExpenseFormdata.Lawyer.split(',');
    } else {
      dataEmployee = 0;
    }
    if (ExpenseFormdata.Description == "") {
      this.alertService.showWarning('Please Enter Expense Description');
    } else if (ExpenseFormdata.NatureofExpense == "0") {
      this.alertService.showWarning('Please Select Nature of Expense');
    } else {
      if (this.ExpenseForForm.invalid) { return; }
      let ae: Addexpense = {
        id: this.expenseID,
        NoticeID: this.Noticeid,
        Description: ExpenseFormdata.Description,
        UnitRate: ExpenseFormdata.UnitRate,
        UnitCount: ExpenseFormdata.NoofUnit,
        Value: ExpenseFormdata.UnitRate * ExpenseFormdata.NoofUnit,
        Date: ExpenseFormdata.ExpenseDate,
        ExpenseNatureID: datavalue[0],
        RegionID: dataRegion[0],
        BranchID: dataBranch[0],
        ExpenseCategoryID: dataCategory[0],
        ExpenseSubCategoryID: dataSubcategory[0],
        EmployeeID: dataEmployee[0],
        recUser: parseInt(localStorage.getItem('LoginUserID')),
        Reason: ExpenseFormdata.Reason,
        ApproveStatus: "2"
      }
      this.http.post(this.url + 'Notice/insertNoticeExpense', ae).subscribe((data) => {
        if (data == null) {
          this.alertService.showError('Expense Not Submitted');
        } else {
          if (this.expenseID == "0") {
            this.alertService.showSuccess('Expense Submitted');
            this.ExpenseForForm.patchValue({
              // NatureofExpense: "0", Region: '0', Branch: '0',ExpenseCategory: '0', ExpenseSubCategory: '0', Description: "", UnitRate: "0", NoofUnit: "0", ExpenseDate: "", drpCaseNotice: null});
              NatureofExpense: "0", Region: '0', Branch: '0', ExpenseCategory: '0', ExpenseSubCategory: '0', Description: "", UnitRate: null, NoofUnit: null, drpCaseNotice: null
            });

          } else {
            this.alertService.showSuccess('Expense Updated');
          }
        }
      }


      );
    }
  }

  //  Import Expense
  onSelectFile(event) {
    this.fileurls = [];
    this.fileName = '';
    if (event.target.files && event.target.files[0]) {
      this.fileName += event.target.files[0].name + ',';
      let reader = new FileReader();
      reader.onload = (event: any) => { this.fileurls.push(event.target.result); };
      reader.readAsDataURL(event.target.files[0]);
    }
  }
  ExpenseFileUpload(ExpenseID) {
    if (ExpenseID != "") {
      if (ExpenseID != undefined) {
        this.expenseID = ExpenseID;
      }
    }
    this.Msg = "";
    if (this.fileName == null || this.fileName == "") {
      this.alertService.showWarning('Please choose file.');
      //return;
    }
    
    this.loading = true;
    let data: EDIFileData = {
      fileBase: this.fileurls,
      fileName: this.fileName,
      ProfileID: this.ProfileID,
      NoticeNo: this.Noticeid,
      ExpenseId: this.expenseID,
    };
    if (this.fileName != undefined) {
      this.http.post(this.url + 'Import/ExpenseUploadFile', data).subscribe((data: ColumnList) => {
        this.loading = false;
        if (data.Status != 200) {
          this.loading = false;
          this.Msg = data.Message;
          this.Status1 = 401;
          return;
        }
        this.EDIRowID = data.EDIRowID;

        this.ModuleData = JSON.parse(data.colList.toString());
        this.CurrentStep = 2;
      },
        (error) => {
          this.loading = false;
          this.Msg = "Internal Server Error.";
          this.Status1 = 401;
        }
      );
    }
  }


  GETEXPENSEFILE() {

    // this.http.get(this.url + 'Notice/cnrMiddleWare?cnrid=' + event.CNRValue) // Update CNR by Middleware

    this.http.get(this.url + 'Import/GETCheckExpenseFile?NoticeID=' + this.NoticeCurrentID + '&ExpenseID=' + this.expenseID)
      .subscribe((data) => {

        this.FullyFileData = JSON.parse(data?.toString());


      }
      );

  }


  GETPREVIEWFILE() {

    // this.http.get(this.url + 'Notice/cnrMiddleWare?cnrid=' + event.CNRValue) // Update CNR by Middleware

    this.http.get(this.url + 'Import/GETPREVIEWFILEWITHEXPENSE?NoticeID=' + this.NoticeCurrentID + '&ExpenseID=' + this.expenseID)
      .subscribe((data) => {
        this.GetPreviewDownloadFile = JSON.parse(data.toString());
        const source = atob(this.GetPreviewDownloadFile[0].FileContent);
        const link = document.createElement("a");
        link.href = source;
        link.download = `${this.GetPreviewDownloadFile[0].FileName}.` + this.GetPreviewDownloadFile[0].FileExt
        link.click();


      }

      );

  }
}
